import { DeleteOutline } from '@mui/icons-material';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import {
  Avatar,
  Card,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Stack } from '@mui/system';
import Edit02Icon from '@untitled-ui/icons-react/build/esm/Edit02';
import moment from 'moment';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LaborLocationTypeIcons } from 'src/pages/therapist-dashboard/dashboard-icon';
import { permissions } from 'src/paths';
import { deleteLaborHoursAction } from 'src/redux/actions/laborHourActions';
import { convertDateToSelectedTimeZone } from 'src/utils/convertDateToSelectedTimeZone';
import { getInitials } from 'src/utils/get-initials';
import LoaderIcon from '../../../src/components/LoaderImg/loader.gif';
import { BootstrapDialog } from '../common-modals/BootstrapDialog';
import ConfirmDeleteModal from './delete-confirmation-modal';
import { clockInActivityType } from 'src/config';
import useFeatureToggle from 'src/hooks/use-feature-toggle';
const LocationType: any = [
  {
    key: 'MILEAGE',
    name: 'Mileage',
  },
  {
    key: 'DRIVE',
    name: 'Drive',
  },
  {
    key: 'BUILDING',
    name: 'Building',
  },
];

type Props = {
  handleRequestLabor: any;
  handleAddNewData: any;
  onPageChange: any;
  onRowsPerPageChange: any;
  page: any;
  rowPerPage: any;
  openDeleteModal: any;
  setOpenDeleteModal: any;
};

const LaborHourManagementTable = (props: Props) => {
  const {
    handleRequestLabor,
    handleAddNewData,
    onRowsPerPageChange,
    page,
    rowPerPage,
    onPageChange,
    openDeleteModal,
    setOpenDeleteModal,
  } = props;

  const dispatch = useDispatch();
  const [checkActivityType] = useFeatureToggle(clockInActivityType, 'ENTERPRISE');
  const getAllLaborHrs = useSelector((state: any) => state.getLaborHoursReducer);
  const getLaborCodesResponse = useSelector((state: any) => state.getLaborCodesReducer?.response);

  const permissionData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.currentPermissions
  );
  const getTherapistProfile = useSelector(
    (state: any) => state.getTherapistProfileReducer?.response?.data
  );
  const { LABOR_MANAGEMENT_ADD, LABOR_MANAGEMENT_DELETE, LABOR_MANAGEMENT_UPDATE } = permissions;

  function calculateFutureTime(totalSec: number): string {
    const hours = Math.floor(totalSec / 3600);
    const minutes = Math.floor((totalSec % 3600) / 60);
    const seconds = totalSec % 60;

    const hoursString = String(hours).padStart(2, '0');
    const minutesString = String(minutes).padStart(2, '0');

    const secondsString = String(seconds).padStart(2, '0');

    return `${hoursString}:${minutesString}:${secondsString}`;
  }

  const [editData, setEditData] = useState('');
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>, lobar_data: any) => {
    setDeleteId(lobar_data?.labourManagementId);

    if (!lobar_data?.clockOut && lobar_data?.locationType !== 'MILEAGE') {
      const newData = { ...lobar_data, clockOut: lobar_data?.clockIn };
      setEditData(newData);
      return setAnchorEl(event.currentTarget);
    }
    setAnchorEl(event.currentTarget);
    setEditData(lobar_data);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [deleteId, setDeleteId] = useState('');

  const handleCloseInfo = () => {
    setOpenDeleteModal(false);
  };

  const confirmHandleDeleteModal = () => {
    dispatch(deleteLaborHoursAction(deleteId));
  };

  const isToday = (date: any) => {
    const today = new Date(convertDateToSelectedTimeZone(new Date()));
    const dateToCheck = new Date(convertDateToSelectedTimeZone(date));

    return (
      dateToCheck.getFullYear() === today.getFullYear() &&
      dateToCheck.getMonth() === today.getMonth() &&
      dateToCheck.getDate() === today.getDate()
    );
  };

  return (
    <>
      <Stack gap="1rem">
        <Card>
          <>
            {getAllLaborHrs?.loading ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  height: '45vh',
                }}
              >
                <img
                  src={LoaderIcon}
                  alt="loader.."
                />
              </div>
            ) : (
              <Box sx={{ minHeight: 500 }}>
                <Table sx={{ minWidth: 700 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Type</TableCell>
                      {getTherapistProfile?.currentRoles?.includes('dor') && checkActivityType ? (
                        <TableCell align="center">Activity Type</TableCell>
                      ) : null}

                      <TableCell>Clock in</TableCell>
                      <TableCell>Clock out</TableCell>
                      <TableCell>Total hours</TableCell>
                      <TableCell>Mileage</TableCell>

                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {!!getAllLaborHrs?.response?.content?.length ? (
                      getAllLaborHrs?.response?.content?.map((lobar_data: any) => {
                        const laborCodeDisplayName =
                          lobar_data?.laborCode &&
                          getLaborCodesResponse?.find(
                            (code: any) => code?.key === lobar_data?.laborCode
                          )?.displayName;
                        return (
                          <TableRow
                            hover
                            key={lobar_data?.labourManagementId}
                          >
                            <TableCell>
                              {' '}
                              <Stack
                                alignItems="center"
                                direction="row"
                                gap="1rem"
                              >
                                <Avatar
                                  sx={{
                                    height: 42,
                                    width: 42,
                                  }}
                                >
                                  {getInitials(lobar_data?.therapistName)}
                                </Avatar>
                                <Typography variant="subtitle2">
                                  {lobar_data?.therapistName}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell>
                              {' '}
                              <Stack
                                flexDirection={'row'}
                                gap={1}
                              >
                                <LaborLocationTypeIcons iconType={lobar_data?.locationType} />{' '}
                                <Typography
                                  variant="body1"
                                  sx={{
                                    textTransform: 'capitalize',
                                  }}
                                >
                                  {' '}
                                  {
                                    LocationType?.find(
                                      (res: any) => res.key == lobar_data?.locationType
                                    )?.name
                                  }
                                </Typography>
                                {laborCodeDisplayName ? (
                                  <Chip
                                    label={`${laborCodeDisplayName}`}
                                    variant="outlined"
                                    sx={{ marginLeft: '10px' }}
                                  />
                                ) : null}
                              </Stack>
                            </TableCell>
                            {getTherapistProfile?.currentRoles?.includes('dor') &&
                            checkActivityType ? (
                              <TableCell align="center">
                                <Typography
                                  variant="body1"
                                  sx={{
                                    textTransform: 'capitalize',
                                  }}
                                >
                                  {lobar_data?.clockInActivityType?.charAt(0)?.toUpperCase() +
                                    lobar_data?.clockInActivityType?.slice(1)?.toLowerCase() || '-'}
                                </Typography>
                              </TableCell>
                            ) : null}

                            <TableCell>
                              {lobar_data?.clockIn
                                ? moment(
                                    new Date(convertDateToSelectedTimeZone(lobar_data?.clockIn))
                                  ).format('hh:mm A')
                                : '-'}
                            </TableCell>
                            <TableCell>
                              {' '}
                              {lobar_data?.clockOut
                                ? moment(
                                    new Date(convertDateToSelectedTimeZone(lobar_data?.clockOut))
                                  ).format('hh:mm A')
                                : '-'}
                            </TableCell>
                            <TableCell>
                              {lobar_data?.totalSec
                                ? calculateFutureTime(lobar_data?.totalSec)
                                : '-'}
                            </TableCell>
                            <TableCell>{lobar_data?.mileage ? lobar_data?.mileage : '-'}</TableCell>
                            <TableCell>
                              <Stack sx={{ marginRight: '10px' }}>
                                <IconButton
                                  disabled={
                                    (!permissionData?.includes(LABOR_MANAGEMENT_UPDATE) &&
                                      !permissionData?.includes(LABOR_MANAGEMENT_DELETE)) ||
                                    (!lobar_data?.clockOut &&
                                      lobar_data?.locationType !== 'MILEAGE' &&
                                      isToday(lobar_data?.clockIn))
                                  }
                                  onClick={(e) => handleClick(e, lobar_data)}
                                >
                                  <MoreVertRoundedIcon />
                                </IconButton>
                                <Menu
                                  id="basic-menu"
                                  anchorEl={anchorEl}
                                  open={open}
                                  onClose={handleClose}
                                  MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                  }}
                                >
                                  {permissionData?.includes(LABOR_MANAGEMENT_UPDATE) && (
                                    <MenuItem
                                      sx={{ gap: '10px', fontWeight: '500', color: '#6C737F' }}
                                      onClick={() => {
                                        handleClose();
                                        handleRequestLabor(editData);
                                      }}
                                    >
                                      <Edit02Icon />
                                      Edit entry
                                    </MenuItem>
                                  )}

                                  {permissionData?.includes(LABOR_MANAGEMENT_DELETE) && (
                                    <MenuItem
                                      sx={{ gap: '10px', fontWeight: '500', color: '#6C737F' }}
                                      onClick={() => {
                                        handleClose();
                                        setOpenDeleteModal(true);
                                      }}
                                    >
                                      <DeleteOutline />
                                      Delete entry
                                    </MenuItem>
                                  )}
                                </Menu>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell colSpan={8}>
                          <Box
                            textAlign="center"
                            p={4}
                          >
                            <Typography
                              color={'text.secondary'}
                              variant="subtitle2"
                            >
                              No Records Found
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            )}
          </>
          <TablePagination
            component="div"
            count={getAllLaborHrs?.response?.totalElements}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
            page={page}
            rowsPerPage={rowPerPage}
            rowsPerPageOptions={[10, 20, 30]}
          />

          {/* <Box
            sx={{
              margin: '20px 11px',
            }}
          >
            <Button
              startIcon={
                <SvgIcon>
                  <PlusIcon />
                </SvgIcon>
              }
              variant="contained"
              onClick={handleAddNewData}
              disabled={!permissionData?.includes(LABOR_MANAGEMENT_ADD)}
            >
              Add
            </Button>
          </Box> */}
        </Card>
      </Stack>
      <BootstrapDialog
        PaperProps={{ style: { maxWidth: '750px' } }}
        onClose={handleCloseInfo}
        aria-labelledby="customized-dialog-title"
        open={openDeleteModal}
      >
        <ConfirmDeleteModal
          close={handleCloseInfo}
          handleDelete={confirmHandleDeleteModal}
        />
      </BootstrapDialog>
    </>
  );
};

export default LaborHourManagementTable;
